import * as React from 'react';

const Pl24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#D80031", d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 12h18V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z" }));
Pl24.Size = 24;
Pl24.Title = "Pl";

export { Pl24 as default };
